import { StructuredText, renderNodeRule } from 'react-datocms'

import { Text } from '@factorialco/deprecated-design-system'
import {
  isBlockquote,
  isHeading,
  isList,
  isListItem,
  isParagraph,
} from 'datocms-structured-text-utils'

import 'modules/marketplace/components/Description/index.styles.css'

type StructuredTextType = {
  id: string | number
  stepByStepDescription: string
}

export const StepByStepDescription = ({ stepByStepDescription, id }: StructuredTextType) => {
  const parsedStepByStepDescription = JSON.parse(stepByStepDescription)

  return (
    <div className={'Description_formattedText'}>
      <StructuredText
        data={parsedStepByStepDescription}
        key={id}
        customNodeRules={[
          renderNodeRule(isHeading, ({ key, children }) => {
            return (
              <div className={'Description_heading'} role="heading" key={key}>
                <Text size="500" weight="medium" color="grey1000">
                  {children}
                </Text>
              </div>
            )
          }),
          renderNodeRule(isBlockquote, ({ key, children }) => {
            return (
              <p className={'Description_blockquote'} key={key}>
                {children}
              </p>
            )
          }),
          renderNodeRule(isList, ({ key, children, node }) => {
            return node.style === 'bulleted' ? (
              <ul className={'Description_unorderedList'} key={key}>
                {children}
              </ul>
            ) : (
              <ol className={'Description_list'} key={key}>
                {children}
              </ol>
            )
          }),
          renderNodeRule(isListItem, ({ key, children }) => {
            return (
              <li className={'Description_listItem'} key={key}>
                {children}
              </li>
            )
          }),
          renderNodeRule(isParagraph, ({ key, children }) => {
            return (
              <p className={'Description_paragraph'} key={key}>
                {children}
              </p>
            )
          }),
        ]}
      />
    </div>
  )
}
